import { TKeys } from './en';
import { CLIENT_BAD_REQUEST_STATUS_STRING, UNKNOWN_ERROR_KEY } from '../api/helper';

export const fr: Record<TKeys, string> = {
  subs_title: 'Gestion de votre abonnement',
  // NAVS
  Home: 'Accueil',
  Voucher: 'Activation Code',
  Profile: 'Profil',
  Subs: 'Abonnements',
  Login: 'Login',
  SignUp: 'Inscription',
  // SCREENS
  onboarding_title: 'Bienvenue sur votre compte Ionnyk!',
  onboarding_s1_title: '1. Validez votre adresse e-mail',
  onboarding_s1_body:
    'Veuillez ouvrir votre client de messagerie, vérifier le dossier spam si nécessaire et cliquer sur le lien fourni. Mail non reçu?',
  onboarding_s2_title: '2. Activez votre bon (le cas échéant)',
  onboarding_s2_body:
    'Si vous avez reçu un bon avec votre cadre Ionnyk et que vous souhaitez activer vos actifs numériques.',
  onboarding_s3_title: "3. Installez et connectez-vous à l'application Ionnyk!",
  onboarding_s3_subtitle: "Utilisez l'application Ionnyk pour gérer votre cadre",
  onboarding_s3_body:
    "Parcourez la galerie, créez des listes de lecture, modifiez les images en fonction des paramètres et des humeurs ou achetez vos œuvres d'art préférées ...",
  profile_title: 'Votre profil',
  profile_empty: 'Sélectionner un champ',
  voucher_title: 'Activer un bon',
  // BUTTONS
  signin_btn: 'Se connecter',
  signup_btn: "S'inscrire",
  save_btn: 'Sauver',
  register_btn: "S'inscrire",
  apply_btn: 'Activer',
  use_voucher_btn: 'Utiliser le voucher',
  sub_upgrade_title: 'Changer votre forfait', // BUTTONS
  logout_btn: 'Déconnexion',
  resend_btn: 'Renvoyer un lien',
  skip_btn: 'PASSER',
  close_btn: 'Fermer',
  gobacklogin_btn: 'Déjà utilisateur? Veuillez vous connecter ici',
  contact_us: 'Un problème technique ?',
  forgotpsw_btn: "J'ai oublié mon mot de passe",
  email_to_confirm:
    "Cette adresse e-mail n'a pas encore été confirmée. Veuillez ouvrir le lien reçu.",
  // FORMS
  email_pl: 'Entrer votre email',
  email_hint: 'Nous ne partagerons jamais votre e-mail avec qui que ce soit.',
  email_label: 'Adresse email',
  psw_pl: 'Mot de passe',
  psw_label: 'Mot de passe',
  psw_hint:
    'Au moins une lettre majuscule, une lettre minuscule, un chiffre, et entre 6 et 32 caractères',
  psw_repeat_label: 'Répéter le mot de passe',
  psw_current_label: 'Mot de passe actuel',
  firstname_pl: 'Prénom',
  firstname_label: 'Prénom',
  lastname_pl: 'Nom',
  lastname_label: 'Nom',
  phone2fa_pl: 'Téléphone (2FA)',
  phone2fa_label: 'Téléphone (2FA)',
  invalid_login: 'E-mail et / ou mot de passe invalide. Veuillez réessayer',
  voucher_hint: "Veuillez noter qu'il ne peut être utilisé qu'une seule fois.",
  voucher_label: 'Veuillez saisir votre bon',
  // FORM validation
  val_misc_format: 'Veuillez vérifier que le format est correct',
  val_non_empty: 'Ne doit pas être vide',
  val_psw_strength:
    'Veuillez vérifier que les mots de passe correspondent. Doit contenir au moins une lettre majuscule, une lettre minuscule, un chiffre et entre 6 et 32 caractères ',
  // General API Error
  [CLIENT_BAD_REQUEST_STATUS_STRING]:
    'Veuillez vérifier les données fournies (champ manquant, trop long ou trop court ou format incorrect)',
  error_title: 'Une erreur est survenue',
  // Subscriptions api
  subs_error_server:
    "Nous n'avons pas pu mettre à jour votre abonnement pour le moment. Veuillez réessayer dans quelques minutes.",
  subs_error_network: 'Aucune réponse du serveur. Veuillez vérifier votre connexion et réessayer.',
  subs_error_polling:
    "L'activation de votre abonnement prend plus de temps que d'habitude. Veuillez actualiser cette page dans quelques minutes.",
  // Subscriptions - plans
  plan_taste_name: 'Taste of Ionnyk',
  plan_taste_intro: 'Inclus avec chaque cadre IONNYK — sans abonnement.',
  plan_taste_f1: '30 œuvres sélectionnées chaque mois',
  plan_taste_f2: '5 photos personnelles à importer chaque mois',
  plan_taste_f3: 'Digital Vault pour vos œuvres et vos photos personnelles',
  plan_taste_outro:
    'Découvrez de nouvelles œuvres et affichez vos propres souvenirs, le tout inclus avec votre cadre.',
  plan_discovery_name: 'Discovery',
  plan_discovery_intro: 'Faites évoluer votre expérience Taste of Ionnyk',
  plan_discovery_f1: "Accès complet au catalogue d'œuvres (2 500+)",
  plan_discovery_f2: 'Récits et contenus exclusifs sur les artistes et les œuvres',
  plan_discovery_f3: '25 photos personnelles à importer chaque mois',
  plan_discovery_f4: 'Digital Vault pour vos œuvres et vos photos personnelles',
  plan_discovery_outro:
    "Explorez toute l'expérience IONNYK avec l'accès à plus de 2 500 œuvres, des récits d'artistes exclusifs, 25 photos personnelles à importer chaque mois et votre propre Digital Vault.",
  plan_signature_name: 'Signature',
  plan_signature_intro: "L'expérience IONNYK ultime",
  plan_signature_f1: "Accès complet au catalogue d'œuvres (2 500+)",
  plan_signature_f2: 'Récits et contenus exclusifs sur les artistes et les œuvres',
  plan_signature_f3: '50 photos personnelles à importer chaque mois',
  plan_signature_f4: 'Digital Vault pour vos œuvres et vos photos personnelles',
  plan_signature_f5: 'Accès exclusif réservé à nos collectionneurs les plus engagés',
  plan_signature_outro:
    "Profitez de l'expérience IONNYK ultime avec l'accès à plus de 2 500 œuvres, des récits d'artistes exclusifs, 50 photos personnelles à importer chaque mois, votre propre Digital Vault et un accès exclusif réservé à nos collectionneurs les plus engagés.",
  // Subscriptions - card status line
  sub_status_active: 'Actif',
  sub_status_trial_ends: "fin de l'essai : {date} ({days} jours)",
  sub_status_next_billing: 'prochain prélèvement : {date}',
  sub_status_until_cancelled: "jusqu'au {date} (résilié)",
  sub_status_until_payment: "jusqu'au {date} (paiement requis)",
  sub_status_cancelled: '(résilié)',
  sub_status_upgrade: 'Faites évoluer votre expérience !',
  sub_status_included: 'Inclus dans votre abonnement',
  sub_status_loading: 'Chargement ...',
  sub_ended_cancellation: 'Résilié le {date}',
  sub_ended_expiration: 'Problème de paiement le {date}',
  sub_ended_trial_expiration: 'Essai expiré le {date}',
  // Subscriptions - card button
  action_active: 'ACTIF',
  action_subscribe: "S'ABONNER",
  action_subscribe_trial: 'ESSAYER GRATUITEMENT*',
  action_required: 'ACTION REQUISE',
  action_add_payment: 'AJOUTER UN PAIEMENT',
  action_manage: 'GÉRER',
  action_included: 'Inclus',
  action_loading: 'Chargement...',
  // Subscriptions - card footer
  price_free: 'GRATUIT',
  price_monthly: '{price} EUR / mois',
  price_yearly: '{price} EUR / an',
  price_save: 'économisez {percent} %',
  trial_days: '{days} jours',
  trial_offer: "d'essai offerts ! *",
  subs_cancel_note:
    '* Vous pouvez résilier votre abonnement à tout moment, mais la période en cours (mensuelle/annuelle) reste due',
  subs_cancel_note_trial:
    '* Vous pouvez résilier votre abonnement à tout moment, mais la période en cours (mensuelle/annuelle, essai exclu) reste due',
  // Subscriptions - toasts
  success_title: 'Succès',
  subs_success: 'Votre abonnement a bien été activé !',
  // Misc
  error_404: 'Page introuvable',
  pay_no_session: 'Aucune session de paiement trouvée',
  // Voucher api errors
  VOUCHER_SUCCESS: 'Succès',
  PREMIUM_SUBSCRIPTION: "L'abonnement Premium a été activé avec succès!",
  VOUCHER_NOT_FOUND: 'Bon non trouvé',
  VOUCHER_EXPIRED: "Le bon n'est plus utilisable (expiré)",
  VOUCHER_ALREADY_USED: 'Le bon a déjà été utilisé',
  PROMOTION_NOT_APPLICABLE: "La promotion n'est pas applicable",
  // Signup api errors
  EMAIL_ALREADY_USED: 'Un compte existe déjà pour cet e-mail. Veuillez vous connecter à la place',
  WEAK_PASSWORD: "Le mot de passe fourni n'est pas assez fort",
  AUTH_FAILED: 'Le mot de passe donné ne correspond pas au mot de passe actuel',
  INVALID_CAPTCHA: 'Captcha non valide, veuillez réessayer plus tard',
  [UNKNOWN_ERROR_KEY]: 'Erreur de serveur inconnue, veuillez réessayer plus tard',
  // Profile api
  profile_updated: 'Le profil a été mis à jour avec succès.',
  // Public
  page_loading: 'Chargement ...',
  pay_cancel_title: 'Votre paiement a été annulé',
  pay_cancel_subtitle: 'Continuez à parcourir le catalogue et reprenez votre achat plus tard.',
  pay_success_title: 'Félicitations !',
  pay_success_subtitle:
    'Votre paiement a été confirmé. Vous allez TRES BIENTOT trouver et pouvoir afficher votre nouvelle oeuvre depuis votre Vault. Ceci peut prendre quelques minutes.',
  forgot_psw_title: 'Mot de passe oublié',
  reset_psw_title: 'Nouveau mot de passe',
  submit_btn: 'Soumettre',
  email_to_send: 'Vous allez recevoir un email',
  invalid_link: 'Le lien est invalide',
  expired_link: 'Le lien est expiré',
  psw_bad_format: "Le mot de passe n'est pas valide (robustesse). Veuillez réeassayer",
  psw_unk_error: 'Echec de mise à jour du mot de passe. Veuillez réeassayer plus tard',
  no_token: 'Token absent',
  success_reset: 'Mot de passe changé avec succès ! Vous allez être redirigé sur le login',
  current_sub: 'Abonnement actif: ',
  freemium: '"Taste of Ionnyk"',
  premium: '"Discovery"',
};
